export default "__VITE_ASSET__B$b0XrO___"